/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {
    DataGrid,
    getGridSingleSelectOperators,
    getGridStringOperators,
    GridToolbarFilterButton
} from "@mui/x-data-grid";

function AdminUsersView(props) {
    const {users, filter,updateFilterPage,isFilterSubmitted,
        numberOfRecords, editData, updateFilterModel} = props
    const usersDataToDisplay = [
        {field: 'id', headerName: "ID", width: 90, sortable: false, filterable: false},
        {field: 'name', headerName: "Meno", width: 200,
            editable: true, sortable: false,filterOperators: getGridStringOperators().filter((o)=>o.value === "contains")},
        {field: 'email', headerName: "Email",
            minWidth: 150, editable: true,
            sortable: false, flex: 1, filterOperators: getGridStringOperators().filter((o)=>o.value === "contains")},
        {
            field: 'role',
            headerName: "Rola",
            minWidth: 150,
            editable: true,
            sortable: false,
            type: 'singleSelect',
            valueOptions: [0,1,2],
            filterOperators: getGridSingleSelectOperators().filter((o)=>o.value === "is"),
            valueFormatter: (p)=>["Používateľ", "Licitator", "Administrator"][p.value]
        },
        {field: 'createdAt', headerName: "Registrovaný", minWidth: 200, type: 'dateTime',sortable: false, valueGetter: ({ value }) => value && new Date(value), filterable: false},
    ]
    return (
            <DataGrid
                rows={users}
                columns={usersDataToDisplay}
                pageSize={filter.req_limit}
                rowsPerPageOptions={[25]}
                rowCount={numberOfRecords}
                paginationMode={"server"}
                pagination
                filterMode={"server"}
                onFilterModelChange={updateFilterModel}
                disableSelectionOnClick
                disableColumnSelector
                disableDensitySelector
                autoHeight
                density={"compact"}
                onCellEditCommit={editData}
                //isCellEditable={(params)=>params.row.id}
                onPageChange={(newPage)=>updateFilterPage(newPage)}
                loading={isFilterSubmitted}
                style={{maxWidth: 1200, margin: "15px auto"}}
                components={{Toolbar: GridToolbarFilterButton}}
            />
    );
}

export default AdminUsersView;